import { ImageWithMetadata, resizeToHeight } from '@features/powerpoint';
import {
  ImageProps,
  Slide,
  inmarketLogo,
  buildSlideMasterFooterText,
} from '@features/powerpoint';
import { parseReportDateToLocaleFormat } from '@utils/dates';
import { Campaign } from '@features/campaigns';
import { theme } from '../domain/theme';
import { FOOTER_TEXT } from './slide-master';
import { DEFAULT_FONT_COLOR, TITLE_SLIDE_MASTER } from '../utils';

const TITLE_FONT_SIZE = 28;
const BRAND_LOGO_HEIGHT = 0.68;
const BRAND_LOGO_Y_POSITION = 2.79;

export const titleSlide = (
  campaign: Pick<Campaign, 'startDate' | 'endDate'>,
  brandLogoWithMetadata: ImageWithMetadata | null,
  campaignName: string
): Slide => {
  const brandLogoImage: ImageProps[] = brandLogoWithMetadata
    ? [
        (() => {
          const resizedBrandLogo = resizeToHeight(
            brandLogoWithMetadata,
            BRAND_LOGO_HEIGHT,
            1.11
          );

          const yPosition =
            resizedBrandLogo.height < BRAND_LOGO_HEIGHT
              ? BRAND_LOGO_Y_POSITION +
                (BRAND_LOGO_HEIGHT - resizedBrandLogo.height) / 2
              : BRAND_LOGO_Y_POSITION;

          return {
            data: resizedBrandLogo.data,
            x: 0.88,
            y: yPosition,
            w: resizedBrandLogo.width,
            h: resizedBrandLogo.height,
          };
        })(),
      ]
    : [];

  return {
    slideMaster: TITLE_SLIDE_MASTER,
    images: [
      {
        path: inmarketLogo,
        x: 0.88,
        y: 2.13,
        w: 2.43,
        h: 0.43,
      },
      ...brandLogoImage,
    ],
    texts: [
      {
        text: 'Attribution'.toUpperCase(),
        options: {
          x: 0.76,
          y: 4.03,
          w: 5.73,
          h: 0.57,
          color: DEFAULT_FONT_COLOR,
          fontSize: TITLE_FONT_SIZE,
          bold: true,
        },
      },
      {
        text: [
          {
            text: 'Lift Conversion Index',
          },
          {
            text: '®',
            options: {
              superscript: true,
            },
          },
          {
            text: ' LCI',
          },
          {
            text: '®',
            options: {
              superscript: true,
            },
          },
        ],
        options: {
          x: 0.76,
          y: 4.53,
          w: 5.9,
          h: 0.57,
          color: DEFAULT_FONT_COLOR,
          fontSize: TITLE_FONT_SIZE,
          bold: true,
        },
      },
      {
        text: 'Real-Time Intelligence. Real-World Impact',
        options: {
          color: theme.colors.inmarketGreen,
          fontSize: 10,
          x: 0.76,
          y: 5.1,
          w: 5.1,
          h: 0.27,
        },
      },
      {
        text: `${campaignName} Campaign Report`.toUpperCase(),
        options: {
          x: 0.76,
          y: 6.55,
          w: 6.63,
          h: 0.34,
          color: DEFAULT_FONT_COLOR,
          fontSize: 14,
        },
      },
      {
        text: [
          parseReportDateToLocaleFormat(campaign.startDate),
          parseReportDateToLocaleFormat(campaign.endDate),
        ].join(' - '),
        options: {
          x: 9.32,
          y: 6.56,
          w: 3.58,
          h: 0.34,
          color: DEFAULT_FONT_COLOR,
          fontSize: 14,
          align: 'right',
        },
      },
      buildSlideMasterFooterText({
        text: FOOTER_TEXT,
      }),
    ],
  };
};
